<template>

    <div>
        <!---------------------------------------------------项目信息-------------------------------------------------------------------->
        <div class="h-piece">
            <div class="h-pieceIn2 n-xiao" v-if="order.orderProjectCode && !showService && order.category1Name != '工程订单'">
                <div class="h-pieceTitle2 " style="margin-left:10px">
                    <h1>项目信息</h1>
                </div>
                <div class="h-pieceCon2">
                    <div class="h-formLine">
                        <el-form :model="order" label-position="right" :inline="true"
                                 class="demo-ruleForm h-formbLine">
                            <el-form-item label="项目名称" class="h-elformWrap-2">
                                <el-input v-model="order.orderProjectName" readonly></el-input>
                            </el-form-item>
                            <el-form-item label="项目版本号" class="h-elformWrap-2">
                                <el-input v-model="order.orderProjectCode" readonly></el-input>
                            </el-form-item>
                            <el-form-item label="项目合同编号" class="h-elformWrap-2">
                                <el-input v-model="order.orderSubContract" readonly></el-input>
                            </el-form-item>
                        </el-form>
                    </div>
                </div>
            </div>
            <!-------------------------------------------------------项目信息-------------------------------------------------------------------->
            <!-------------------------------------------------------订单信息-------------------------------------------------------------------->

            <div class="h-pieceIn2">
                <div class="h-pieceTitle2" style="margin-left:10px">
                    <h1>订单信息</h1>
                </div>
                <div class="h-pieceCon2">
                    <div class="h-formLine n-two">
                        <el-form label-position="right" :inline="true"
                                 class="demo-ruleForm h-formbLine">
                            <el-form-item label="项目名称" class="h-elformWrap-2" v-if="order.category1Name == '工程订单'">
                                <el-input v-model="order.orderProjectName" readonly></el-input>
                            </el-form-item>
                            <el-form-item label="项目版本号" class="h-elformWrap-2" v-if="order.category1Name == '工程订单'">
                                <el-input v-model="order.orderProjectCode" readonly></el-input>
                            </el-form-item>
                            <el-form-item label="项目备注" class="h-elformWrap-2" v-if="order.category1Name == '工程订单'">
                                <el-input v-model="order.projectDescription" readonly :title="order.projectDescription"></el-input>
                            </el-form-item>
                            <el-form-item label="订单类型" class="h-elformWrap-2">
                                <el-input v-model="xsqyStr" readonly></el-input>
                            </el-form-item>
                            <el-form-item label="销售组织" class="h-elformWrap-2">
                                <el-input v-model="xszzStr" readonly></el-input>
                            </el-form-item>
                            <el-form-item label="创建人" class="h-elformWrap-2">
                                <el-input v-model="this.order.cuname" readonly></el-input>
                            </el-form-item>
                            <el-form-item label="创建时间" class="h-elformWrap-2">
                                <el-input v-model="this.order.cdate" readonly></el-input>
                            </el-form-item>
                            <!--<el-form-item label="成本中心" class="h-elformWrap-2" v-if="showIsFree">-->
                                <!--<el-select v-model="order.costCenter" style="width: 100%;" disabled>-->
                                    <!--<el-option v-for="item in costList" :key="item.index"-->
                                               <!--:label="`${item.costCenterCode} : ${item.remark}`"-->
                                               <!--:value="item.costCenterCode"></el-option>-->
                                <!--</el-select>-->
                            <!--</el-form-item>-->
                            <el-form-item label="订购原因" class="h-elformWrap-2" v-if="showIsFree">
                                <brselect clearable category="business_reason" :v="order.businessReason"
                                          v-model="order.businessReason" disabled></brselect>
                            </el-form-item>
                            <el-form-item label="增值税登记号" class="h-elformWrap-2" v-if="aflag">
                                <el-input v-model="this.order.vatNo" readonly></el-input>
                            </el-form-item>
                            <el-form-item label="税号1" class="h-elformWrap-2" v-if="aflag">
                                <el-input v-model="this.order.taxNo" readonly></el-input>
                            </el-form-item>
                            <el-form-item label="数据线" class="h-elformWrap-2" v-if="aflag">
                                <el-input v-model="this.order.dataWire" readonly></el-input>
                            </el-form-item>

                            <el-form-item label="样品机合同" class="h-elformWrap-2" v-if="showSampleHetong">
                                <brupload
                                        :refid=this.order.id
                                        reftype="样品机合同"
                                        :limit="1"
                                        :showtime="false"
                                        :uploadflag="false"
                                        :delflag="false"
                                >
                                </brupload>
                            </el-form-item>
                            <!--
                            <el-form-item label="备注" class="h-elformWrap-2">
                                <el-input v-model="this.order.note" readonly></el-input>
                            </el-form-item>
                            -->
                        </el-form>
                    </div>
                </div>
            </div>
            <!-------------------------------------------------------订单信息-------------------------------------------------------------------->

            <!-------------------------------------------------------客户信息-------------------------------------------------------------------->
            <div class="h-pieceIn2">
                <div class="h-pieceTitle2" style="margin-left:10px">
                    <h1>客户信息</h1>
                </div>
                <div class="h-pieceCon2">
                    <div class="h-formLine n-two">
                        <el-form :model="order" ref="form1" label-position="right" :inline="true"
                                 class="demo-ruleForm h-formbLine">
                            <el-form-item prop="soldToName" label="售达方名称"
                                          class="h-elformWrap-2">
                                <el-input v-model="order.soldToName" readonly/>
                            </el-form-item>

                            <el-form-item prop="soldToAreaName" label="售达方区域" class="h-elformWrap-2"
                                          v-if="!showService">
                                <el-input v-model="order.soldToAreaName" readonly placeholder="自带出"></el-input>
                            </el-form-item>
                            <el-form-item label="售达方销售区域" class="h-elformWrap-2">
                                <el-input v-model="order.salesregionName" readonly placeholder="自带出"></el-input>
                            </el-form-item>
                            <el-form-item prop="customerChannelCode" label="客户渠道" class="h-elformWrap-2">
                                <brselect
                                        :disabled="true"
                                        category="sales_region" :v="order.customerChannelCode"
                                        v-model="order.customerChannelCode"></brselect>
                            </el-form-item>

                            <el-form-item prop="isStockUp" label="是否备货" class="h-elformWrap-2"
                                          v-if="!showIsFree&&!showService">
                                <brselect category="shifou_keyong" disabled :v="order.isStockUp"
                                          v-model="order.isStockUp"></brselect>
                            </el-form-item>
                            <el-form-item prop="toCompanyname" label="收货单位" class="h-elformWrap-2" v-if="!showService">
                                <el-input v-model="order.toCompanyname" :class="{'addredclass':regionaddflag}" readonly></el-input>
                            </el-form-item>

                            <el-form-item prop="contactName" label="收货联系人" class="h-elformWrap-2">
                                <el-input v-model="order.contactName" readonly></el-input>
                            </el-form-item>
                            <el-form-item
                                    :label="receivedTimeName"
                                    class="h-elformWrap-2"
                                    prop="receivedTime">
                                <div class="block">
                                    <el-input v-model="order.receivedTime" readonly></el-input>
                                </div>
                            </el-form-item>

                            <el-form-item label="联系电话" class="h-elformWrap-2" prop="firsttelephone">
                                <div class="block">
                                    <el-input v-model="order.firsttelephone" readonly
                                    ></el-input>
                                </div>
                            </el-form-item>
                            <el-form-item label="收货地址" prop="toAddress" class="h-elformWrap-2"
                                          v-if="!showService">
                                <el-input  v-model="order.toAddress" :title="order.toAddress" readonly>
                                </el-input>
                            </el-form-item>

                            <el-form-item prop="kucun" label="库位" v-if="this.order.orderCategory1 == '4' || this.order.orderCategory1 == '26'" class="h-elformWrap-2">
                                <brselect clearable
                                          :disabled="true"
                                          category="order_shouh_kuwei"
                                          :v="order.kucun"
                                          v-model="order.kucun"></brselect>
                            </el-form-item>

                        </el-form>
                    </div>
                </div>
            </div>
            <!-------------------------------------------------------客户信息-------------------------------------------------------------------->

            <!--------------------------------售后信息--------------->
            <div class="h-pieceIn2" v-if="showshouhouflag">
                <div class="h-pieceTitle2" style="margin-left:10px;">
                    <h1>售后信息</h1>
                </div>
                <div class="h-pieceCon2">
                    <div class="h-formLine n-two">
                        <el-form :model="order" ref="form2" label-position="right" :inline="true"
                                 class="demo-ruleForm h-formbLine">
                            <!--<el-form-item prop="tuihyy" label="退货原因" :rules="[-->
                            <!--{ required: true, message: '请输入退货原因', trigger: 'change'},-->
                            <!--]"  class="h-elformWrap-2">-->
                            <!--<brselect clearable category="tuihuo_yuanyin" :v="order.tuihyy"-->
                            <!--v-model="order.tuihyy"></brselect>-->
                            <!--</el-form-item>-->
                            <el-form-item prop="tuihyydes" label="质量检测描述" class="h-elformWrap-2">
                                <el-input v-model="order.tuihyydes" placeholder="质量检测描述" style="width: 13rem;" readonly></el-input>
                            </el-form-item>
                        </el-form>
                    </div>
                </div>
            </div>

            <!-------------------------------------------------------产品信息-------------------------------------------------------------------->
            <div  class="h-table h-mrt30 ljjtablepaddings" style="margin: 20px 20px 0 20px;">
                <div class="h-pieceTitle2 message">
                    <h1 v-if="showshouhouflag"><span v-if="productlist9390.length>0">发货产品信息</span></h1>
                    <h1 v-else>发货产品信息</h1>
                </div>
                <div v-if="productlist9390.length>0">
                    <span style="color: #4a4a4a">青岛海尔生物医疗股份有限公司(9390)</span>
                    <el-form label-position="right" :inline="true" ref="form9390" :model="order"
                             class="demo-ruleForm h-formbLine" style="width: 100%;margin-top: 20px;">
                        <el-form-item label="成本中心" prop="costCenter9390" v-if="showIsFree&&!showIsFreeSh" style="width: 50%;">
                            <el-select v-model="order.costCenter9390" style="width: 350px;" disabled
                                       placeholder="--选择--">
                                <el-option v-for="item in costList9390" :key="item.index"
                                           :label="`${item.costCenterCode} : ${item.remark}`"
                                           :value="item.costCenterCode"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-form>
                    <el-table
                            ref="multipleTable"
                            @selection-change="handleSelectionChange9390"
                            :data="productlist9390"
                            stripe
							border
                            style="width: 100%">
                        <el-table-column
                                type="selection"
                                width="40"
                                label="全选">
                        </el-table-column>
                        <el-table-column
                                type="index"
                                label="#"
                                width="40">
                        </el-table-column>
                        <el-table-column
                                prop="proModelName"
                                label="产品大类"
                                :show-overflow-tooltip="true"
                                width="110">
                        </el-table-column>
                        <el-table-column
                                prop="sapCode"
                                label="订单号"
								:show-overflow-tooltip="true"
                                width="120">
                        </el-table-column>
                        <el-table-column
                                prop="materialCode"
                                label="产品编码"
								:show-overflow-tooltip="true"
                                width="160">
                        </el-table-column>
                        <el-table-column
                                prop="materialName"
                                label="产品名称"
                                min-width="190"
                                :show-overflow-tooltip="true">
									<template slot-scope="scope">
										<div style="text-align: left;">
											{{scope.row.materialName}}
										</div>
									</template>
                        </el-table-column>
                        <el-table-column
                                prop="proNumber"
                                label="订单数量"
                                width="100">
								<template slot-scope="scope">
									<div style="text-align: right;">
										{{scope.row.proNumber}}
									</div>
								</template>
                        </el-table-column>
						<el-table-column
								v-if="showRent"
                                :key="Math.random()"
						        prop="cwddh"
						        label="财务订单号"
						        width="140">
						</el-table-column>
                        <el-table-column
                                prop="proBenchmarkPrice"
                                :label="priceName"
                                width="110">
								<template slot-scope="scope">
									<div style="text-align: right;">
										{{scope.row.proBenchmarkPrice}}
									</div>
								</template>
                        </el-table-column>
                        <el-table-column
                                v-if="showOEMflag"
                                :key="Math.random()"
                                prop="cgmll"
                                label="毛利率"
                                width="120">
                            <template slot-scope="scope">
                                {{scope.row.cgmll | numFilter}}
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="currencyCode"
                                label="币种"
                                width="80">
                        </el-table-column>
                        <el-table-column
                                v-if="tejieshowflag"
                                :key="Math.random()"
                                prop="specialPrice"
                                label="特价"
                                width="120"
                        >
							<template slot-scope="scope">
								<div style="text-align: right;">
									{{scope.row.specialPrice}}
								</div>
							</template>
                        </el-table-column>
                        <el-table-column
                                v-if="tejieshowflag"
                                :key="Math.random()"
                                prop="sid"
                                label="特价版本号"
                                min-width="210"
                        >
                        </el-table-column>
                        <el-table-column
                                v-if="tejieshowflag"
                                :key="Math.random()"
                                prop="projectName"
                                label="特价项目名称"
                                min-width="180"
                        >
							<template slot-scope="scope">
								<div style="text-align: left;">
									{{scope.row.projectName}}
								</div>
							</template>
                        </el-table-column>
                        <el-table-column
                                v-if="tejieshowflag"
                                :key="Math.random()"
                                prop="proDiscount"
                                label="高/低特价"
                                min-width="110"
                        >
                             <template slot-scope="scope">
                              <div v-if="scope.row.specialPrice <= scope.row.proBenchmarkPrice">低</div>
                              <div v-else>高</div>
                             </template>
                        </el-table-column>
                        <el-table-column
                                v-if="showSamplePro"
                                :key="Math.random()"
                                prop="discount"
                                label="打折级别"
                                width="150">
                            <template slot-scope="scope">
                                <brselect class="h-tableInput" disabled category="sample_product_discount" :v="scope.row.discount"
                                          v-model="scope.row.discount"/>
                            </template>
                        </el-table-column>

                        <el-table-column
                                v-if="dingzhishowflag && !showService"
                                :key="Math.random()"
                                prop="extraDes"
                                label="定制需求"
                                width="150">
									<template slot-scope="scope">
										<div style="text-align: left;">
											{{scope.row.extraDes}}
										</div>
									</template>
                        </el-table-column>

                        <el-table-column
                                v-if="dingzhishowflag && !showService"
                                :key="Math.random()"
                                prop="extraPrice"
                                label="定制加价"
                                width="110">
									<template slot-scope="scope">
										<div style="text-align: right;">
											{{scope.row.extraPrice}}
										</div>
									</template>
                        </el-table-column>

                        <el-table-column
                                prop="finalPrice"
                                label="成交价"
                                width="110">
									<template slot-scope="scope">
										<div style="text-align: right;">
											{{scope.row.finalPrice}}
										</div>
									</template>
                        </el-table-column>

                        <el-table-column
                                prop="taxRate"
                                label="税率"
                                v-if="this.order.orderCategory1 == 9"
                                :key="Math.random()"
                                width="110">
									<template slot-scope="scope">
										<div style="text-align: right;">
											{{new big(scope.row.taxRate||0).times(100).minus(100).toString() + '%'}}
										</div>
									</template>
                        </el-table-column>

                        <el-table-column
                                prop="jinejjz"
                                label="净价值"
                                width="110">
									<template slot-scope="scope">
										<div style="text-align: right;">
											{{scope.row.jinejjz}}
										</div>
									</template>
                        </el-table-column>

                        <el-table-column
                                prop="totalprice"
                                label="总价"
                                width="110"
                        >
							<template slot-scope="scope">
								<div style="text-align: right;">
									{{scope.row.totalprice}}
								</div>
							</template>
                        </el-table-column>
                        <el-table-column
                                prop="note1"
                                label="备注"
                                :show-overflow-tooltip="true"
                                width="110"
                        >
							<template slot-scope="scope">
								<div style="text-align: right;">
									{{scope.row.note1}}
								</div>
							</template>
                        </el-table-column>

                    </el-table>
                    <div class="jieguo" v-if="!showIsFree">
                    <span class="jieguo_label">订单总价</span>
                    <span class="jieguo_value">{{ order9390.orderPrice }}</span>

                    <span class="jieguo_label">现金占用</span>
                    <span class="jieguo_value">{{ order9390.orderPriceXj }}</span>

                    <span class="jieguo_label">现金欠款</span>
                    <span class="jieguo_value">{{ order9390.orderPriceXjQk }}</span>

                    <span class="jieguo_label">信贷占用</span>
                    <span class="jieguo_value">{{ order9390.orderPriceXd }}</span>

                    <span class="jieguo_label">净价值</span>
                    <span class="jieguo_value">{{ order9390.orderNetWorth }}</span>
                </div>
                </div>

                <div v-if="productlist9370.length>0" >
                    <span style="color: #4a4a4a">青岛海尔生物医疗科技有限公司(9370)</span>
                    <el-form label-position="right" :inline="true" ref="form9370" :model="order"
                             class="demo-ruleForm h-formbLine" style="width: 100%;margin-top: 20px;">
                        <el-form-item label="成本中心" prop="costCenter9370" v-if="showIsFree&&!showIsFreeSh" style="width: 50%;">
                            <el-select v-model="order.costCenter9370" style="width: 350px;" disabled
                                       placeholder="--选择--">
                                <el-option v-for="item in costList9370" :key="item.index"
                                           :label="`${item.costCenterCode} : ${item.remark}`"
                                           :value="item.costCenterCode"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-form>
                    <el-table
                            ref="multipleTable"
                            @selection-change="handleSelectionChange9370"
                            :data="productlist9370"
                            stripe
							border
                            style="width: 100%">
                        <el-table-column
                                type="selection"
                                width="40"
                                label="全选">
                        </el-table-column>
                        <el-table-column
                                type="index"
                                label="#"
                                width="40">
                        </el-table-column>
                        <el-table-column
                                prop="proModelName"
                                label="产品大类"
                                :show-overflow-tooltip="true"
                                width="110">
                        </el-table-column>
                        <el-table-column
                                prop="sapCode"
                                label="订单号"
								:show-overflow-tooltip="true"
                                width="120">
                        </el-table-column>
                        <el-table-column
                                prop="materialCode"
                                label="产品编码"
								:show-overflow-tooltip="true"
                                width="160">
                        </el-table-column>
                        <el-table-column
                                prop="materialName"
                                label="产品名称"
                                min-width="190"
                                :show-overflow-tooltip="true">
									<template slot-scope="scope">
										<div style="text-align: left;">
											{{scope.row.materialName}}
										</div>
									</template>
                        </el-table-column>
                        <el-table-column
                                prop="proNumber"
                                label="订单数量"
								:show-overflow-tooltip="true"
                                width="100">
									<template slot-scope="scope">
										<div style="text-align: right;">
											{{scope.row.proNumber}}
										</div>
									</template>
                        </el-table-column>
						<el-table-column
								v-if="showRent"
						        prop="cwddh"
								:show-overflow-tooltip="true"
						        label="财务订单号"
						        width="140">
						</el-table-column>
                        <el-table-column
                                prop="proBenchmarkPrice"
                                :label="priceName"
								:show-overflow-tooltip="true"
                                width="110">
                        </el-table-column>
                        <el-table-column
                                v-if="showOEMflag"
                                prop="cgmll"
                                label="毛利率"
								:show-overflow-tooltip="true"
                                width="120">
                            <template slot-scope="scope">
                                {{scope.row.cgmll | numFilter}}
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="currencyCode"
                                label="币种"
								:show-overflow-tooltip="true"
                                width="110">
                        </el-table-column>
                        <el-table-column
                                v-if="tejieshowflag"
                                prop="specialPrice"
                                label="特价"
								:show-overflow-tooltip="true"
                                width="120"
                        >
							<template slot-scope="scope">
								<div style="text-align: right;">
									{{scope.row.specialPrice}}
								</div>
							</template>
                        </el-table-column>
                        <el-table-column
                                v-if="tejieshowflag"
                                prop="specialOfferCode"
                                label="特价版本号"
								:show-overflow-tooltip="true"
                                min-width="210"
                        >
                        </el-table-column>
                        <el-table-column
                                v-if="tejieshowflag"
                                prop="projectName"
                                label="特价项目名称"
								:show-overflow-tooltip="true"
                                min-width="180"
                        >
							<template slot-scope="scope">
								<div style="text-align: left;">
									{{scope.row.projectName}}
								</div>
							</template>
                        </el-table-column>
                        <el-table-column
                                v-if="tejieshowflag"
                                prop="proDiscount"
                                label="高/低特价"
                                min-width="110"
                        >
                             <template slot-scope="scope">
                              <div v-if="scope.row.specialPrice <= scope.row.proBenchmarkPrice">低</div>
                              <div v-else>高</div>
                             </template>
                        </el-table-column>
                        <el-table-column
                                v-if="showSamplePro"
                                prop="discount"
                                label="打折级别"
                                width="150">
                            <template slot-scope="scope">
                                <brselect disabled category="sample_product_discount" :v="scope.row.discount"
                                          v-model="scope.row.discount"/>
                            </template>
                        </el-table-column>

                        <el-table-column
                                v-if="dingzhishowflag && !showService"
                                prop="extraDes"
                                label="定制需求"
								:show-overflow-tooltip="true"
                                width="150">
									<template slot-scope="scope">
										<div style="text-align: left;">
											{{scope.row.extraDes}}
										</div>
									</template>
                        </el-table-column>

                        <el-table-column
                                v-if="dingzhishowflag && !showService"
                                prop="extraPrice"
                                label="定制加价"
								:show-overflow-tooltip="true"
                                width="110">
									<template slot-scope="scope">
										<div style="text-align: right;">
											{{scope.row.extraPrice}}
										</div>
									</template>
                        </el-table-column>

                        <el-table-column
                                prop="finalPrice"
                                label="成交价"
								:show-overflow-tooltip="true"
                                width="110">
									<template slot-scope="scope">
										<div style="text-align: right;">
											{{scope.row.finalPrice}}
										</div>
									</template>
                        </el-table-column>

                        <el-table-column
                                prop="taxRate"
                                label="税率"
                                v-if="this.order.orderCategory1 == 9"
                                width="110">
									<template slot-scope="scope">
										<div style="text-align: right;">
											{{new big(scope.row.taxRate||0).times(100).minus(100).toString() + '%'}}
										</div>
									</template>
                        </el-table-column>

                        <el-table-column
                                prop="jinejjz"
                                label="净价值"
								:show-overflow-tooltip="true"
                                width="110">
									<template slot-scope="scope">
										<div style="text-align: right;">
											{{scope.row.jinejjz}}
										</div>
									</template>
                        </el-table-column>

                        <el-table-column
                                prop="totalprice"
                                label="总价"
								:show-overflow-tooltip="true"
                                width="110"
                        >
							<template slot-scope="scope">
								<div style="text-align: right;">
									{{scope.row.totalprice}}
								</div>
							</template>
                        </el-table-column>
                            <el-table-column
								prop="note1"
								label="备注"
								:show-overflow-tooltip="true"
								width="110"
                            >
								<template slot-scope="scope">
									<div style="text-align: left;">
										{{scope.row.note1}}
									</div>
								</template>

                        </el-table-column>
                    </el-table>
                    <div class="jieguo" v-if="!showIsFree">
                    <span class="jieguo_label">订单总价</span>
                    <span class="jieguo_value">{{ order9370.orderPrice }}</span>

                    <span class="jieguo_label">现金占用</span>
                    <span class="jieguo_value">{{ order9370.orderPriceXj }}</span>

                    <span class="jieguo_label">现金欠款</span>
                    <span class="jieguo_value">{{ order9370.orderPriceXjQk }}</span>

                    <span class="jieguo_label">信贷占用</span>
                    <span class="jieguo_value">{{ order9370.orderPriceXd }}</span>

                    <span class="jieguo_label">净价值</span>
                    <span class="jieguo_value">{{ order9370.orderNetWorth }}</span>
                </div>
                </div>

                <div v-if="productlist9391.length>0">
                    <span style="color: #4a4a4a">上海销售组织(9391)</span>
                    <el-form label-position="right" :inline="true" ref="form9391" :model="order"
                             class="demo-ruleForm h-formbLine" style="width: 100%;margin-top: 20px;">
                        <el-form-item label="成本中心" prop="costCenter9391" v-if="showIsFree || showIsFreeSh" style="width: 50%;">
                            <el-select v-model="order.costCenter9391" style="width: 350px;" disabled
                                       placeholder="--选择--">
                                <el-option v-for="item in costList9391" :key="item.index"
                                           :label="`${item.costCenterCode} : ${item.remark}`"
                                           :value="item.costCenterCode"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-form>
                    <el-table
                            ref="multipleTable"
                            @selection-change="handleSelectionChange9391"
                            :data="productlist9391"
                            stripe
							border
                            style="width: 100%">
                        <el-table-column
                                type="selection"
                                width="40"
                                label="全选">
                        </el-table-column>
                        <el-table-column
                                type="index"
                                label="#"
                                width="40">
                        </el-table-column>
                        <el-table-column
                                prop="proModelName"
                                label="产品大类"
                                :show-overflow-tooltip="true"
                                width="110">
                        </el-table-column>
                        <el-table-column
                                prop="sapCode"
                                label="订单号"
								:show-overflow-tooltip="true"
                                width="120">
                        </el-table-column>
                        <el-table-column
                                prop="materialCode"
                                label="产品编码"
								:show-overflow-tooltip="true"
                                width="160">
                        </el-table-column>
                        <el-table-column
                                prop="materialName"
                                label="产品名称"
                                min-width="190"
                                :show-overflow-tooltip="true">
								<template slot-scope="scope">
									<div style="text-align: left;">
										{{scope.row.materialName}}
									</div>
								</template>
                        </el-table-column>
                        <el-table-column
                                prop="proNumber"
                                label="订单数量"
								:show-overflow-tooltip="true"
                                width="100">
									<template slot-scope="scope">
										<div style="text-align: right;">
											{{scope.row.proNumber}}
										</div>
									</template>
                        </el-table-column>
						<el-table-column
								v-if="showRent"
						        prop="cwddh"
						        label="财务订单号"
								:show-overflow-tooltip="true"
                                :key="Math.random()"
						        width="140">
						</el-table-column>
                        <el-table-column
                                prop="proBenchmarkPrice"
                                :label="priceName"
								:show-overflow-tooltip="true"
                                width="110">
									<template slot-scope="scope">
										<div style="text-align: right;">
											{{scope.row.proBenchmarkPrice}}
										</div>
									</template>
                        </el-table-column>
                        <el-table-column
                                v-if="showOEMflag"
                                prop="cgmll"
                                label="毛利率"
								:show-overflow-tooltip="true"
                                :key="Math.random()"
                                width="120">
                            <template slot-scope="scope">
                                {{scope.row.cgmll | numFilter}}
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="currencyCode"
                                label="币种"
								:show-overflow-tooltip="true"
                                width="110">
                        </el-table-column>
                        <el-table-column
                                v-if="tejieshowflag"
                                prop="specialPrice"
                                label="特价"
								:show-overflow-tooltip="true"
                                width="120"
                                :key="Math.random()"
                        >
							<template slot-scope="scope">
								<div style="text-align: right;">
									{{scope.row.specialPrice}}
								</div>
							</template>
                        </el-table-column>
                        <el-table-column
                                v-if="tejieshowflag"
                                prop="specialOfferCode"
                                label="特价版本号"
								:show-overflow-tooltip="true"
                                min-width="210"
                                :key="Math.random()"
                        >
                        </el-table-column>
                        <el-table-column
                                v-if="tejieshowflag"
                                prop="projectName"
                                label="特价项目名称"
								:show-overflow-tooltip="true"
                                min-width="180"
                                :key="Math.random()"
                        >
							<template slot-scope="scope">
								<div style="text-align: left;">
									{{scope.row.projectName}}
								</div>
							</template>
                        </el-table-column>
                        <el-table-column
                                v-if="tejieshowflag"
                                prop="proDiscount"
                                label="高/低特价"
                                min-width="110"
                                :key="Math.random()"
                        >
                             <template slot-scope="scope">
                              <div v-if="scope.row.specialPrice <= scope.row.proBenchmarkPrice">低</div>
                              <div v-else>高</div>
                             </template>
                        </el-table-column>
                        <el-table-column
                                v-if="showSamplePro"
                                prop="discount"
                                label="打折级别"
                                :key="Math.random()"
                                width="150">
                            <template slot-scope="scope">
                                <brselect disabled category="sample_product_discount" :v="scope.row.discount"
                                          v-model="scope.row.discount"/>
                            </template>
                        </el-table-column>

                        <el-table-column
                                v-if="dingzhishowflag && !showService"
                                prop="extraDes"
                                label="定制需求"
								:show-overflow-tooltip="true"
                                width="150">
								<template slot-scope="scope">
									<div style="text-align: left;">
										{{scope.row.extraDes}}
									</div>
								</template>
                        </el-table-column>

                        <el-table-column
                                v-if="dingzhishowflag && !showService"
                                prop="extraPrice"
                                label="定制加价"
								:show-overflow-tooltip="true"
                                width="110">
									<template slot-scope="scope">
										<div style="text-align: right;">
											{{scope.row.extraPrice}}
										</div>
									</template>
                        </el-table-column>

                        <el-table-column
                                prop="finalPrice"
                                label="成交价"
								:show-overflow-tooltip="true"
                                width="110">
									<template slot-scope="scope">
										<div style="text-align: right;">
											{{scope.row.finalPrice}}
										</div>
									</template>
                        </el-table-column>

                        <el-table-column
                                prop="taxRate"
                                label="税率"
                                v-if="this.order.orderCategory1 == 9"
                                :key="Math.random()"
                                width="110">
									<template slot-scope="scope">
										<div style="text-align: right;">
											{{new big(scope.row.taxRate||0).times(100).minus(100).toString() + '%'}}
										</div>
									</template>
                        </el-table-column>

                        <el-table-column
                                prop="jinejjz"
                                label="净价值"
								:show-overflow-tooltip="true"
                                width="110">
									<template slot-scope="scope">
										<div style="text-align: right;">
											{{scope.row.jinejjz}}
										</div>
									</template>
                        </el-table-column>

                        <el-table-column
                                prop="totalprice"
                                label="总价"
								:show-overflow-tooltip="true"
                                width="110"
                        >
							<template slot-scope="scope">
								<div style="text-align: right;">
									{{scope.row.totalprice}}
								</div>
							</template>
                        </el-table-column>
                    </el-table>
                    <div class="jieguo" v-if="!showIsFree">
                    <span class="jieguo_label">订单总价</span>
                    <span class="jieguo_value">{{ order9391.orderPrice }}</span>

                    <span class="jieguo_label">现金占用</span>
                    <span class="jieguo_value">{{ order9391.orderPriceXj }}</span>

                    <span class="jieguo_label">现金欠款</span>
                    <span class="jieguo_value">{{ order9391.orderPriceXjQk }}</span>

                    <span class="jieguo_label">信贷占用</span>
                    <span class="jieguo_value">{{ order9391.orderPriceXd }}</span>

                    <span class="jieguo_label">净价值</span>
                    <span class="jieguo_value">{{ order9391.orderNetWorth }}</span>
                </div>
                </div>
            </div>
            <!-------------------------------------------------------产品信息-------------------------------------------------------------------->
            <!--退回产品信息-->
            <div v-if="showshouhouflag && productlist2.length>0" class="h-table h-mrt30 "
                 style="margin: 20px 20px 0 20px;">
                <div class="h-pieceTitle2 message" style="margin-bottom: 0.3rem;">
                    <h1 class="h1">退货产品信息</h1>
                </div>
                <el-table
                        ref="multipleTable"
                        :data="productlist2"
                        stripe
						border
                        style="width: 100%">
                    <el-table-column
                            fixed
                            type="index"
                            label="#"
                            width="40">
                    </el-table-column>
                    <el-table-column
                            prop="proModelName"
                            label="产品大类"
                            :show-overflow-tooltip="true"
                            width="110">
                    </el-table-column>
                    <el-table-column
                            prop="sapCode"
                            label="订单号"
							:show-overflow-tooltip="true"
                            width="120">
                    </el-table-column>
                    <el-table-column
                            prop="materialCode"
                            label="产品编码"
							:show-overflow-tooltip="true"
                            width="160">
                    </el-table-column>
                    <el-table-column
                            prop="materialName"
                            min-width="190"
                            :show-overflow-tooltip="true"
                            label="产品名称">
								<template slot-scope="scope">
									<div style="text-align: left;">
										{{scope.row.materialName}}
									</div>
								</template>
                    </el-table-column>
                    <el-table-column
                            prop="proNumber"
                            label="订单数量"
							:show-overflow-tooltip="true"
                            width="100">
								<template slot-scope="scope">
									<div style="text-align: right;">
										{{scope.row.proNumber}}
									</div>
								</template>
                    </el-table-column>
                    <el-table-column
                            prop="proBenchmarkPrice"
                            label="基准价"
							:show-overflow-tooltip="true"
                            width="150">
								<template slot-scope="scope">
									<div style="text-align: right;">
										{{scope.row.proBenchmarkPrice}}
									</div>
								</template>
                    </el-table-column>
                    <el-table-column
                            prop="currencyCode"
                            label="币种"
							:show-overflow-tooltip="true"
                            width="110">
                    </el-table-column>
                    <el-table-column
                            prop="finalPrice"
                            label="成交价"
							:show-overflow-tooltip="true"
                            width="150">
								<template slot-scope="scope">
									<div style="text-align: right;">
										{{scope.row.finalPrice}}
									</div>
								</template>
                    </el-table-column>
                    <el-table-column
                            prop="totalprice"
                            label="总价"
							:show-overflow-tooltip="true"
                            width="120">
								<template slot-scope="scope">
									<div style="text-align: right;">
										{{scope.row.totalprice}}
									</div>
								</template>
                        <template slot-scope="scope">
                            {{ (scope.row.totalprice = new big(scope.row.proNumber || 0).times((scope.row.finalPrice ||
                            scope.row.proBenchmarkPrice || 0)).toString())}}
                        </template>
                    </el-table-column>
                </el-table>
            </div>

            <viewhistory :visible.sync="showhistory" v-if="showhistory" :id="instid"/>
        </div>
        <div class="h-table h-mrt30    bbbb" v-if="this.taskstatus == '1' && this.order.shifouyidi == '1' && this.order.orderCategory1!='4' " >
            <div class="h-pieceTitle2 hang">
                <h1 class="h1">区域经理审批意见</h1>
                <el-form :model="spform" label-position="right" :inline="true"
                         class="demo-ruleForm h-formbLine ">
					<el-form-item label="审批意见" class="h-elformWrap-2 " style="margin:0.2rem;">
						<div style="border-bottom: 1px solid #dedede;">{{this.qyjlspyj?this.qyjlspyj:'&nbsp;'}}</div>
					</el-form-item>
					<el-form-item  label="权益归属" prop="shouyiarea" class="h-elformWrap-2"
					              style="margin:0 0.2rem 0.2rem 0.2rem">
					    <div style="border-bottom: 1px solid #dedede;">{{this.shouyiareacode|dictname('YLRegion')}}</div>
					</el-form-item>
                </el-form>
            </div>
        </div>
        <div class="h-table h-mrt30    bbbb" v-if="this.taskstatus == '0'">
            <div class="h-pieceTitle2 hang">
                <h1 class="h1">审批意见</h1>
                <el-form :model="spform" label-position="right" :inline="true"
                         class="demo-ruleForm h-formbLine ">
                    <el-form-item label="审批意见" class="h-elformWrap-2 " style="margin:20px" :required="true">
                        <el-input v-model="spform.shpyj" placeholder="请输入"
                        ></el-input>
                    </el-form-item>
                    <el-form-item v-if="showshouyiList" label="确认权益归属" prop="shouyiarea" class="h-elformWrap-2"
                                  style="margin:20px">
                        <el-select v-model="spform.shouyiarea"
                                   placeholder="请选择">
                            <el-option
                                    v-for="item in shouyiList"
                                    :key="item.code"
                                    :label="item.name"
                                    :value="item.code">
                            </el-option>
                        </el-select>

                    </el-form-item>
                </el-form>
            </div>
        </div>
        <div class="anniu" v-if="this.taskstatus == '0' ">
            <el-button class="el-button h-btn h-bBtn h-bgwhite el-button--default" @click="saveOrSubmit(0)">返回</el-button>
<!--            <el-button v-if="this.shenqingzuofeiList[0].status == '71' " class="el-button h-btn h-bBtn h-bgblueQ2 el-button&#45;&#45;default"-->
<!--                       @click="sapDeleteOrder(2)">申请作废信息</el-button>-->
            <el-button class="el-button h-btn h-bBtn h-bgred el-button--default"
                       @click="saveOrSubmit(2)">驳回
            </el-button>
            <el-button class="el-button h-btn h-bBtn h-bggreen el-button--default" @click="saveOrSubmit(1)">通过
            </el-button>
            <el-button class="el-button h-btn el-button--default"
                       @click="viewpress">审批跟踪
            </el-button>
        </div>
        <div class="anniu" v-if="this.taskstatus == '1'">
            <el-button class="el-button h-btn h-bBtn h-bgwhite el-button--default" @click="saveOrSubmit(0)">返回</el-button>
<!--            <el-button class="el-button h-btn h-bBtn h-bgblueQ2 el-button&#45;&#45;default" @click="sapDeleteOrder(1)">申请作废</el-button>-->
            <el-button class="el-button h-btn el-button--default"
                       @click="viewpress">审批跟踪
            </el-button>
        </div>

        <el-dialog :close-on-click-modal="false" title="申请作废订单" :visible.sync="zfyydialogFormVisible">
            <el-form :model="zuofeiyy">
                <el-form-item label="作废原因" :label-width="'100'">
                    <brselect category="DD_ZFYY" :v="zuofeiyy"
                              v-model="zuofeiyy" ></brselect>
                </el-form-item>
                <el-form-item label="附件上传" :label-width="'100'">
                    <brupload
                            :refid=order.id
                            reftype="申请订单作废附件"
                            :limit="1"
                            :showtime="false"
                            uploadflag
                            delflag
                    >
                    </brupload>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button class="h-btn h-bBtn h-bgwhite" @click="zfyydialogFormVisible = false">取 消</el-button>
                <el-button class="h-btn h-bBtn" @click="submitzuofei">确 定</el-button>
            </div>
        </el-dialog>
    </div>

</template>

<script>
    import big from 'big.js'
    import ss from '../../api/SystemService'


    export default {
    //     let id = this.$route.query.ywid || this.$route.query.id;
    //
    // let instid = this.$route.query.instid;
    // let taskid = this.$route.query.taskid;
    // let taskstatus = this.$route.query.taskstatus;
        props:["orderid","orderinstid","ordertaskid","ordertaskstatus"],
        filters: {
            numFilter(value) {
                let realVal = ''
                if (value) {
                    // 截取当前数据到小数点后两位
                    realVal = parseFloat(value).toFixed(2) * 100 + '%'
                } else {
                    realVal = '--'
                }
                return realVal
            }
        },
        data() {
            return {
                regionaddflag:false,
				showRent : false,
                shenqingzuofeiList: [],
                //选中的
                selectedList: [],
                //作废弹窗
                zfyydialogFormVisible:false,
                showSampleHetong: false,
                //作废原因
                zuofeiyy:null,
                chooseOrder9390:[],
                chooseOrder9370:[],
                chooseOrder9391:[],
                priceName: "基准价",
                costList: [],
                costList9390: [],
                costList9370: [],
                costList9391: [],
                receivedTimeName: "预计收货日期",
                showIsFree: false,
                showIsFreeSh:false,
                showSamplePro: false,
                showshouhouflag: false,
                showService: false,
                showOEMflag: false,
                aflag: false,
                instid: null,
                tejieshowflag: false,
                dingzhishowflag: false,
                spform: {
                    ywid: null,
                    taskid: null,
                    taskstatus: null,
                    optflag: null,
                    shpyj: null,
                    shouyiarea: null,
                    orderMainProductList: null,
                },
                showhistory: false,
                //确认收益展示
                showshouyiList: false,
                shouyiList: [],//选择地址
                qyjlspyj:null,//区域经理审批意见
                shouyiareacode:null,//收益区域
                order: {
                    id: null, // 主键
                    orderMainContract: null, // 主合同编号
                    orderSubContract: null, // 分合同编号
                    orderProjectCode: null, // 项目编号
                    orderProjectName: null, // 项目名称
                    projectDescription: null, // 项目描述
                    orderCategory: null, // 订单类型
                    orderCategory1: null, // 订单详细类型:1-10为内销：1-工程,2-标准,3-改制,4-售后,5-样品机,6-免费,7-展会,8-租赁,9-服务,10-OEM,
                    saleGroupCode: null, // 销售组织编码:6200-青岛海尔生物医疗-香港销组织,9390-青岛,9391-上海,9370-青岛海特生物医疗-销售组织
                    disChannelCode: null, // 分销渠道编码:00-通用分销渠道,X1-香港外销渠道,Z1-上海直销渠道
                    zCode: null, // 分销渠道编码-子编码
                    customerChannelCode: null, // 客户渠道
                    isStockUp: null, // 是否备货      1：是；0：否
                    orderStatus: null, // 订单状态： 10:暂存  20:审核中, 21:订单管理员通过, 22:订单管理员未通过, 23:财务经理未通过, 24:财务经理通过   30:sap已提交,31:sap待审核,32:sap已通过
                    instid: null, // 流程id
                    tuihyy: null, // 退货原因
                    tuihyydes: null, // 退货原因说明
                    contactName: null, // 联系人名称
                    receivedTime: null, // 预计收货时间
                    soldToCode: null, // 售达方编码
                    soldToName: null, // 售达方名称
                    salesregion: null, // 售达方销售名称
                    soldToAreaCode: null, // 售达方地区编码
                    shipToCode: null, // 送达方编码
                    shipToName: null, // 送达方名称
                    shipToAreaCode: null, // 送达方地区编码
                    invoiceCode: null, // 开票方编码
                    payerCode: null, // 付款方编码
                    currencyCode: null, // 币种编码
                    orderPrice: 0, // 订单总价
                    orderPriceXj: 0, // 订单现金占用
                    creditid: null, // 信贷id
                    orderPriceXd: 0, // 订单信贷占用
                    orderPriceXjQk: 0, // 现金欠款
                    orderNetWorth: 0, // 订单净价值
                    poId: null, // PO号
                    areaId: null, // 区域详情表关联id
                    dcCode: null, // 配送中心编码
                    toProvincesCode: null, // 送达省份编码
                    toCityCode: null, // 送达城市编码
                    note: null, // 订单备注
                    postcode: null, // 邮政编码
                    firsttelephone: null, // 第一个电话
                    secondtelephone: null, // 第二电话
                    extraPrice: null, // 定制加价
                    customized: null, // 定制需求
                    sapsended: null, // 是否已提交sap,1-是,0-否
                    toAddress: null, // 收货地址
                    toCompanyname: null, // 送达方公司全称

                    categoryName: null,
                    category1Name: null,
                    saleGrputName: null,
                    disChannelName: null,
                    zcodeName: null,

                },
//行项目
                productlist9390: [],
                productlist9370: [],
                productlist9391: [],

                order9390: {
                    orderPrice:0,
                    orderPriceXj:0,
                    orderPriceXjQk:0,
                    orderPriceXd:0,
                    orderNetWorth:0,
                },
                order9370: {
                    orderPrice:0,
                    orderPriceXj:0,
                    orderPriceXjQk:0,
                    orderPriceXd:0,
                    orderNetWorth:0,
                },
                order9391: {
                    orderPrice:0,
                    orderPriceXj:0,
                    orderPriceXjQk:0,
                    orderPriceXd:0,
                    orderNetWorth:0,
                },

            //     <span class="jieguo_value">{{ order.orderPrice }}</span>
            //
            // <span class="jieguo_label">现金占用</span>
            //     <span class="jieguo_value">{{ order.orderPriceXj }}</span>
            //
            // <span class="jieguo_label">现金欠款</span>
            //     <span class="jieguo_value">{{ order.orderPriceXjQk }}</span>
            //
            // <span class="jieguo_label">信贷占用</span>
            //     <span class="jieguo_value">{{ order.orderPriceXd }}</span>
            //
            // <span class="jieguo_label">净价值</span>
            //     <span class="jieguo_value">{{ order.orderNetWorth }}</span>


                //产品list
                productlist1: [],
                productlist2: [],
                gscode: null,

                //用户信贷list
                creditData: [],

            }
        },
        //页面加载前事件
        created() {

            // console.log(1111,this.$router);
            //都是行项目订单id
            // let id = this.$route.query.ywid || this.$route.query.id;

            // let instid = this.$route.query.instid;
            // let taskid = this.$route.query.taskid;
            // let taskstatus = this.$route.query.taskstatus;
            this.instid = this.orderinstid;
            this.taskstatus = this.ordertaskstatus;
            this.spform.ywid = this.orderid;
            this.spform.taskid = this.ordertaskid;
            this.getOrder(this.orderid,this.ordertaskid);
        },
        computed: {
            xsqyStr() {
                if (this.order.category1Name) {
                    return this.order.categoryName + "/" + this.order.category1Name
                }
                return this.order.categoryName
            },
            xszzStr() {
                return "(" + this.gscode + ")" + this.$store.getters.dictname('YLSalesOrganization_agent', this.gscode);
            },
            fxqdStr() {
                if (this.order.zcodeName) {
                    return this.order.disChannelName + "/" + this.order.zcodeName
                }
                return this.order.disChannelName
            },
            total() {
                return this.rows.map(
                    row => row.purchaseCount * row.price).reduce(
                    (acc, cur) => (parseFloat(cur) + acc), 0)
            }
        },

        watch: {
            productlist1: {
                immediate: true,
                deep: true,
                handler(newValue, oldValue) {

                    //计算总净价值
                    this.order.orderNetWorth = _.reduce(_.map(newValue, "jinejjz"), function (sum, v) {
                        return new big(sum).plus(v).toString();
                    }, 0)
                },
            },

            // orderPrice:0,
            // orderPriceXj:0,
            // orderPriceXjQk:0,
            // orderPriceXd:0,
            productlist9390: {
                immediate: true,
                deep: true,
                handler(newValue, oldValue) {
                    // console.log(11111,newValue)
                    //计算总金额
                    this.order9390.orderPrice = _.reduce(_.map(newValue, "totalprice"), function (sum, v) {
                        return new big(sum).plus(v).toString();
                    }, 0)
                    this.order9390.orderPriceXj = _.reduce(_.map(newValue, "jinexj"), function (sum, v) {
                        return new big(sum).plus(v).toString();
                    }, 0)
                    this.order9390.orderPriceXjQk =  _.maxBy(newValue, "jinexjqk")?_.maxBy(newValue, "jinexjqk")['jinexjqk']:0;
                    //计算总净价值
                    this.order9390.orderNetWorth = _.reduce(_.map(newValue, "jinejjz"), function (sum, v) {
                        return new big(sum).plus(v).toString();
                    }, 0)
                    //信贷合计
                    this.order9390.orderPriceXd = _.reduce(_.map(newValue, "jinexd"), function (sum, v) {
                        return new big(sum).plus(v).toString();
                    }, 0)
                },
            },
            productlist9370: {
                immediate: true,
                deep: true,
                handler(newValue, oldValue) {
                    // console.log(newValue)
                    //计算总金额
                    this.order9370.orderPrice = _.reduce(_.map(newValue, "totalprice"), function (sum, v) {
                        return new big(sum).plus(v).toString();
                    }, 0)
                    this.order9370.orderPriceXj = _.reduce(_.map(newValue, "jinexj"), function (sum, v) {
                        return new big(sum).plus(v).toString();
                    }, 0)
                    this.order9370.orderPriceXjQk =  _.maxBy(newValue, "jinexjqk")?_.maxBy(newValue, "jinexjqk")['jinexjqk']:0;
                    //计算总净价值
                    this.order9370.orderNetWorth = _.reduce(_.map(newValue, "jinejjz"), function (sum, v) {
                        return new big(sum).plus(v).toString();
                    }, 0)
                    //信贷合计
                    this.order9370.orderPriceXd = _.reduce(_.map(newValue, "jinexd"), function (sum, v) {
                        return new big(sum).plus(v).toString();
                    }, 0)

                },
            },
            productlist9391: {
                immediate: true,
                deep: true,
                handler(newValue, oldValue) {
                    // console.log(newValue)
                    //计算总金额
                    this.order9391.orderPrice = _.reduce(_.map(newValue, "totalprice"), function (sum, v) {
                        return new big(sum).plus(v).toString();
                    }, 0)
                    this.order9391.orderPriceXj = _.reduce(_.map(newValue, "jinexj"), function (sum, v) {
                        return new big(sum).plus(v).toString();
                    }, 0)
                    this.order9391.orderPriceXjQk =  _.maxBy(newValue, "jinexjqk")?_.maxBy(newValue, "jinexjqk")['jinexjqk']:0;
                    //计算总净价值
                    this.order9391.orderNetWorth = _.reduce(_.map(newValue, "jinejjz"), function (sum, v) {
                        return new big(sum).plus(v).toString();
                    }, 0)
                    //信贷合计
                    this.order9391.orderPriceXd = _.reduce(_.map(newValue, "jinexd"), function (sum, v) {
                        return new big(sum).plus(v).toString();
                    }, 0)

                },
            }
        },

        methods: {

            //申请作废订单
            sapDeleteOrder(x) {
                if(x == '1' && (!this.selectedList || this.selectedList.length < 1)){
                    // console.log('我在这儿呀', this.selectedList);
                    this.$msg.msge("请选择要申请作废的产品行!");
                    return;
                }
                this.zfyydialogFormVisible = true;
            },
            submitzuofei(){
                if (!this.zuofeiyy) {
                    this.$msg.msge("请选择作废原因");
                    return false;
                }
                var id = _.join(_.map(this.selectedList,"id"),",");
                var yybz = this.zuofeiyy+":"+this.$store.getters.dictname("DD_ZFYY",this.zuofeiyy);
                this.$msg.confirm("确认申请作废?", () => {
                    ss.OrderMainService.shenqingzuofei(id, yybz).then(rd => {
                        this.$msg.msgs(rd.msg);
                        this.query();
                        this.zfyydialogFormVisible = false
                    });
                });
            },

            handleSelectionChange9390(v){
                this.chooseOrder9390 = v;
                this.selectedList = v;
                // console.log(this.chooseOrder9390)
            },
            handleSelectionChange9370(v){
                this.chooseOrder9370 = v;
                this.selectedList = v;
                // console.log(this.chooseOrder9370)
            },
            handleSelectionChange9391(v){
                this.chooseOrder9391 = v;
                this.selectedList = v;
                // console.log(this.chooseOrder9391)
            },
            getOrder(id,taskid) {
                ss.OrderMainService.selectById(id,taskid).then(rd => {
                    this.regionaddflag = rd.obj.regionadd;
                    console.log("111111111,1111111",this.regionaddflag);
                    // console.log(rd.obj.products, '订单列表')
                    this.shenqingzuofeiList = rd.obj.products;
                    this.zuofeiyy = this.shenqingzuofeiList[0].deleteReason;
                    // this.productlist1 = rd.obj.products
                    _.assign(this.order, rd.obj)


                    // 获取当前节点的task
                    if (this.spform.taskid) {
                        ss.taskservice.getTaskByTaskid(this.spform.taskid).then(result => {
                            //确认收益
                            if (rd.shouyiList && rd.shouyiList.length > 0) {
                                this.shouyiList = rd.shouyiList
                                if(this.shouyiList && this.shouyiList.length>0){
                                    var seled = _.find(this.shouyiList,{selected:true});
                                    if(seled){
                                        this.spform.shouyiarea = seled.code;
                                    }
                                }
                                //区域经理，总部确认审批
                                // if (result.code == "quyujinglishenpinode" || result.code == "zongbuquerennode") {
                                if (result.code == "quyujinglishenpinode" || result.code == "zongbuquerennode") {
                                    this.showshouyiList = true;
                                } else {
                                    this.showshouyiList = false;
                                }
                            }
                        })
                    }

                    let type = this.order.orderCategory1;
                    //存在行项目
                    if (rd.obj.products && rd.obj.products.length > 0) {
                        rd.obj.products.forEach((obj) => {
                            if (obj) {
                                this.gscode = obj.gscode;
                                this.addProject(obj)
                            }
                        })
                    }

                    //售后订单
                    if (type == '4') {
                        this.showshouhouflag = true
                    } else if (type == '6'|| type == '33') {
                        this.priceName = "成本价";
                        //免费订单
                        this.showIsFree = true;
                        if (type == '33') {
                            this.showIsFreeSh = true;
                        }
                        ss.OrderMainService.getCostCenterList({companyCode: "9390"}).then(rd => {
                            this.costList9390 = rd;
                        })
                        ss.OrderMainService.getCostCenterList({companyCode: "9370"}).then(rd => {
                            this.costList9370 = rd;
                        })
                        ss.OrderMainService.getCostCenterList({companyCode: "9391"}).then(rd => {
                            this.costList9391 = rd;
                        })
                    } else if (type == '5') {
                        //样品机订单
                        this.showSamplePro = true;
                        this.showSampleHetong = true;
                    } else if (type == '9') {
                        //服务类订单
                        this.showService = true;
                        this.receivedTimeName = "计划发货日";
                    } else if (type == '32') {
                        //上海oem类订单
                        this.showOEMflag = true;
                    } else if (type == '8') {
						//租赁订单
						this.showRent = true;
					}
                })
            },
            addProject(obj) {
                //区域经理审批意见
                if(!this.qyjlspyj){
                    this.qyjlspyj = obj.yidishpyj||null;
                }
                if(!this.shouyiareacode){
                    this.shouyiareacode = obj.shouyiarea||null;
                }
                // console.log("获取到的是南通单list",obj)
                if(!this.order['costCenter' + obj.gscode]){
                    this.order['costCenter' + obj.gscode] = obj.costCenter||null;
                }
                if (obj.specialPrice) {
                    this.tejieshowflag = true;
                }
                if (obj.extraPrice) {
                    this.dingzhishowflag = true;
                }
                // if (obj.shouyiarea) {
                //     this.spform.shouyiarea = obj.shouyiarea
                // }
                this.order.orderPrice = obj.totalprice; // 订单现金占用
                this.order.orderPriceXj = obj.jinexj; // 订单现金占用
                this.order.orderPriceXd = obj.jinexd; // 订单信贷占用
                this.order.orderPriceXjQk = obj.jinexjqk; // 订单欠款
                this.order.orderNetWorth = new big(obj.totalprice || 0).div(1.13).toFixed(2);
                // this.order.costCenter = obj.costCenter;
                if (obj.orderztype == '发货单') {
                    // this.productlist1.push(obj);
                    this['productlist' + obj.gscode].push(obj);
                } else {
                    this.productlist2.push(obj);
                }
            },
            viewpress(r) {
                this.showhistory = true;
            },
            backtolist() {
                this.$router.go(-1);
            },
            saveOrSubmit(v) {

                console.log(this)
                // console.log('我在这儿呀', v);
                if(v != '0' && (!this.selectedList || this.selectedList.length < 1)){
                    this.$msg.msge("请先勾选要处理的产品行!");
                    return;
                }
                if (v == '2') {
                    this.spform.optflag = '驳回'
                    if (!this.spform.shpyj) {
                        this.$msg.msge("驳回必须输入审批意见！");
                        return;
                    }
                } else if (v == '1') {
                    this.spform.optflag = '通过'
                } else {
                    //点击详情进来的
                    if (this.$route.query.f == '1') {
                        this.$router.back();
                        return;
                    }
                    this.$emit('refreshSelf',{close:true,refresh:false});
                    return;
                }
                var confirmMsg = this.selectedList[0].status == '71' && v == '1' ? "通过后会直接作废订单,确认通过?" : "确认提交?";
                this.$msg.confirm(confirmMsg, () => {
                    this.submitForm();
                })
            },
            submitForm() {
                this.spform.orderMainProductList = _.concat(this.chooseOrder9370,this.chooseOrder9390,this.chooseOrder9391);
                console.log("this.spform::",this.spform)
                ss.OrderMainService.shpsaveOrSubmit(this.spform).then(rd => {
                    this.$msg.alerts("提交成功！", () => {
                        //刷新右上角的代办个数
                        this.$store.dispatch("searchTasktotal")
                        if (this.$route.query.f == '1') {
                            this.$router.back();
                            return;
                        }
                        this.$emit('refreshSelf',{close:true,refresh:true});
                        return;
                    })
                })
                
            },


        }
    }

</script>


<style scoped>
    .anniu {
        display: flex;
        justify-content: center;
        align-items: center;
		margin-top: 0.3rem;
    }


    .jieguo {
        border-bottom: 1px solid rgb(238, 236, 236);
        display: flex;
    }

    .jieguo .jieguo_label {
        width: 1.5rem;
        text-align: right;
        background-color: #ebf5ff;
        font-size: 0.16rem;
        color: #616467;
        height: 0.4rem;
        line-height: 0.4rem;
        padding: 0 0.05rem;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .jieguo .jieguo_value {
        width: 20%;
        font-size: 0.16rem;
        color: #616467;
        height: 0.4rem;
        line-height: 0.4rem;
        padding: 0px 8px;
    }

    .h-piece {
        margin: 20px;
    }

    .h1 {
        margin-left: 27px;
    }

    .n-xiao .h-formbLine .h-elformWrap-2,
    .n-two .h-formbLine .h-elformWrap-2 {
        width: 33.333%;
    }

    .hang {
        padding: 20px 0;
        background-color: white;
    }

    .bbbb {
        background-color: white;
        margin: 0 20px;

    }
</style>
<style>
    .showflowDialogcls .el-dialog__body{
        padding-top: 0px!important;
    }
    .h-formbLine .el-form-item__content .addredclass .el-input__inner{
        color: #ff7875;
    }
    .h-formbLine .el-form-item__content .el-input__inner[disabled] {
        color: #868686;
    }

    .n-two .h-formbLine .el-form-item__content .el-select,
    .n-two .el-form .h-formbLine .el-form-item__content .el-select {
        width: 0;
    }

    .n-xiao .h-formbLine .el-form-item__label,
    .n-two .h-formbLine .el-form-item__label {
        width: 43%;
    }

    .n-xiao .h-formbLine .el-form-item__content,
    .n-two .h-formbLine .el-form-item__content {
        width: 57%;
    }

	.ljjtablepaddings .h-tableInput .el-input__inner{
		padding: 0.05rem 0.1rem;
	}
	.ljjtablepaddings .h-tableInput .el-input__icon{
		line-height: 0.25rem;
	}
</style>
